module.exports = __webpack_public_path__ + "img/brand-pic2-08.def5c4ac.png";